export default "__VITE_ASSET__BtF$$G1W__"